import React from "react";
import ReactDOM from "react-dom"
import App from "./Services/App";
import {Router} from "@morningtrain/react-navigation";
import assign from "object-assign";
import {Env} from "@morningtrain/helpers";
import get from "lodash/get";
import ReactDOMServer from "react-dom/server";

let global = window || global;

function attachServerSideRenderer() {

    /// Prepare global storage of components so that is doesn't get overriden
    /// by other entry scripts that contain this renderer
    global["reactComponents"] = global["reactComponents"] || {};
    global["renderComponent"] = global["renderComponent"] || function (component, props) {
        const Component = get(global["reactComponents"], component);

        if (Component == null) {
            return "";
        }

        return ReactDOMServer.renderToString(<Component {...props} />);
    };

}

class Renderer {

    constructor() {
        this.components = {};
        this.references = {};

        if (Env.server()) {
            attachServerSideRenderer();
        }
    }

    register(namespace, components) {
        this.components[namespace] = this.components[namespace] || {};
        assign(this.components[namespace], components);

        /// Register global components if server side
        if (Env.server()) {
            global["reactComponents"][namespace] = global["reactComponents"][namespace] || {};
            assign(global["reactComponents"][namespace], components);
        }

        return this;
    }

    render() {
        document.querySelectorAll("[data-react-class]").forEach((element) => {
            let components = this.components;

            let Component = get(components, element.dataset.reactClass);
            let props = JSON.parse(element.dataset.reactProps);
            let ref = element.dataset.reactRef;

            if (typeof Component === 'undefined' || Component === null) {
                throw new Error('Failed to mount react component: ' + element.dataset.reactClass);
            }

            let rootComponentName = Env.get('page.component');
            console.log(rootComponentName, element.dataset.reactClass)

            let JSX = (<Component {...props}/>);

            if (rootComponentName === element.dataset.reactClass) {
                JSX = (
                    <App />
                );
            }

            let component = ReactDOM.render(
                JSX,
                element
            );

            if (typeof ref === "string" && (ref.length > 0) && component) {
                this.references[ref] = component;
            }
        });

        return this;
    }

    element(reference) {
        return this.references[reference];
    }

}

export default new Renderer();
